$(function(){
    $('#estimatedShippingCostToggle').on('change', function(){
        let shippingCostContainer  = $('#shippingCostContainer');
        let estimatedShippingCost  = $('#estimatedShippingCostContainer');
        if($(this).is(':checked')){
            shippingCostContainer.hide();
            shippingCostContainer.find('input').prop('disabled', true);
            estimatedShippingCost.show();
            estimatedShippingCost.find('input').prop('disabled', false);
        }
        else{
            shippingCostContainer.show();
            shippingCostContainer.find('input').prop('disabled', false);
            estimatedShippingCost.hide();
            estimatedShippingCost.find('input').prop('disabled', true);
        }
    });
});